export default "https://cdn-static.gokick.com/assets/392c20f622263512bf2611e9ba1d645afacce893/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";